<template>
  <div>
    <router-view />
    <LogTracker />
    <DiagnosticsDialog />
    <footer class="only-print">
      <div class="created-by-text">
        Creado con
      </div>
      <img src="~assets/images/logo-binnacle-light.png" class="footer-logo" alt="logo">
    </footer>
  </div>
</template>

<script>
import { languageMixin } from './mixins/language'
import { pushNotificationsMixin } from './mixins/pushNotifications'
import inactivityMixin from './mixins/inactivity'
import LogTracker from './components/LogTracker.vue'
import DiagnosticsDialog from './components/DiagnosticsDialog.vue'
import { StatusBar, Style } from '@capacitor/status-bar'
import { SystemBars, SystemBarsStyle, SystemBarType } from '@capacitor/core'
import { App as CapacitorApp } from '@capacitor/app'
import { Device } from '@capacitor/device'
export default {
  name: 'App',
  components: {
    LogTracker,
    DiagnosticsDialog
  },
  mixins: [
    languageMixin,
    pushNotificationsMixin,
    inactivityMixin
  ],
  mounted () {
    window.onafterprint = () => {
      document.getElementsByTagName('body')[0].style.width = '100%'
    }

    if (this.$q.platform.is.capacitor) {
      CapacitorApp.addListener('appRestoredResult', this._onAppRestoredResult).then((handle) => {
        this._appRestoredResultListener = handle
      })
      StatusBar.setBackgroundColor({ color: '#B8353D' })
      StatusBar.setStyle({ style: Style.Light })
      this._applySystemBarsStyle()
    }
  },
  beforeUnmount () {
    this._appRestoredResultListener?.remove()
  },
  methods: {
    // Android 15+ (API 35) fuerza edge-to-edge y vuelve no-op a setBackgroundColor;
    // setStyle legacy NO esta gateado por SDK y sigue aplicando en 15+. SystemBars
    // es la via soportada para pedir iconos claros sobre el header rojo.
    // OJO con las semanticas invertidas entre plugins:
    // StatusBar Style.Light = iconos oscuros, SystemBarsStyle.Dark = iconos claros.
    // Sin el gate por SDK esta llamada invertiria los iconos en toda la flota
    // (incluidas las EDA51 con Android 10), donde manda el estilo legacy de arriba.
    async _applySystemBarsStyle () {
      try {
        const { androidSDKVersion } = await Device.getInfo()
        if (androidSDKVersion >= 35) {
          SystemBars.setStyle({ style: SystemBarsStyle.Dark, bar: SystemBarType.StatusBar })
        }
      } catch (error) {
        console.error(error)
      }
    },
    // Android puede matar el WebView cuando la cámara está abierta.
    // En ese caso la promesa de Camera.getPhoto() nunca resuelve; Capacitor
    // entrega el resultado via appRestoredResult cuando el WebView se recrea.
    _onAppRestoredResult (result) {
      if (result.pluginId !== 'Camera') return

      if (!result.success) {
        this.$q.localStorage.remove('pendingCameraAction')
        return
      }

      const pending = this.$q.localStorage.getItem('pendingCameraAction')
      if (!pending) return

      const fileUri = result.data?.path || result.data?.webPath
      if (!fileUri) return

      // Escribir al localStorage ANTES de navegar para que el created()
      // del componente destino siempre encuentre imageURL listo
      this.$q.localStorage.set('pendingCameraAction', { ...pending, imageURL: fileUri })

      if (pending.path && this.$route.path !== pending.path) {
        // Delay de 150ms — garantiza que el router completa la navegación
        // antes de que el componente destino monte su created() hook
        setTimeout(() => {
          this.$router.push(pending.path).catch(() => {})
        }, 150)
      }
    }
  }
}
</script>
